// @flow
import { createAction } from 'redux-actions';

export const fetchDistributionStatus = createAction(
  '@client/FETCH_DISTRIBUTION_STATUS',
  (clientId: Id) => clientId
);

export const storeDistributionStatus = createAction(
  '@client/STORE_DISTRIBUTION_STATUS',
  (isPwrDistro: boolean | Error) => isPwrDistro
);



// WEBPACK FOOTER //
// ./src/containers/client/distributionActions.js